import { render, staticRenderFns } from "./SendDocumentTemplateRegister.vue?vue&type=template&id=5ea7bb8b&scoped=true&lang=pug"
import script from "./SendDocumentTemplateRegister.vue?vue&type=script&lang=ts"
export * from "./SendDocumentTemplateRegister.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentTemplateRegister.vue?vue&type=style&index=0&id=5ea7bb8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea7bb8b",
  null
  
)

export default component.exports